<template>
  <div class="content">
    <h1>Projects</h1>
    <section class="projects-featured">
      <ProjectThumbnail
          v-for="(project, index) in projects"
          :key="project.id"
          :index="index"
          :loaded="true"
          :id="project.id"
          :urlPostFix="project.urlPostFix"
          :title="project.name"
          :thumbnails="project.thumbnail"/>
      <ProjectThumbnail
          v-if="loading"
          v-for="n in 4"
          :key="n"/>
      <div
          v-if="failed"
          :loaded="true"
          class="project-feature failed">
        Failed to load featured projects.
      </div>
    </section>
    <button v-if="isMore && !loading" v-on:click="moreClick" class="btn btn-primary w-100">View More Projects</button>
  </div>
</template>

<script>
import ProjectThumbnail from '@/components/ProjectThumbnail';
import API from '../class/API';
export default {
  name: 'projects',
  components: { ProjectThumbnail },
  title() {
    return 'Projects';
  },
  asyncData() {
    getProjects(1);
  },
  data() {
    return {
      loading: true,
      failed: false,
      projects: [],
      isMore: false,
      currentPage: 1
    };
  },
  beforeMount() {
    getProjects(this.currentPage).then((data) => {
      this.loading = false;
      this.failed = false;
      this.projects = data.projects.slice(0);
      this.isMore = data.isMore;
      this.currentPage++;
    });
  },
  methods: {
    moreClick: function(event) {
      this.loading = true;
      getProjects(this.currentPage).then((data) => {
        this.loading = false;
        this.failed = false;
        data.projects.forEach((project) => { this.projects.push(project); });
        this.isMore = data.isMore;
        this.currentPage++;
      });
    }
  }
};

/**
 * Get projects
 * @param {Number} page
 * @returns {Promise}
 */
function getProjects(page) {
  return API.request('GET', `project/list/${page}`, [], true).send();
}
</script>


<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/views/Projects.vue